import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { H2, P, SvgIcon, Span } from '../Jet.style';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${vw(80)};
  padding: ${vw(80)} ${vw(100)};
`;

const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;

const Head = styled.div`
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  width: ${vw(800)};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;
  span {
    font-weight: 700;
  }
  img {
    position: absolute;
    top: 50%;
    left: -25%;
    transform: translateY(-50%);
  }
`;

const Link = styled.a`
  display: block;
  border: 2px solid #000;
  padding: ${vw(8)} 0;
  width: ${vw(250)};
  border-radius: ${vw(16)};
  font-size: ${vw(16)};
  font-weight: 700;
  line-height: 1.5;
  color: #050a30;
  text-decoration: none;
  text-align: center;
  position: absolute;
  top: 50%;
  right: -40%;
  transform: translateY(-50%);

  :hover {
    border-color: #40a9ff;
  }
`;

const SectionLists = [
  {
    title: '24/7 Concierge, Catering, and Pet-Friendly Flights',
    desc: 'Our 24/7 global service support team supports those booking even the biggest private jets and offers multilingual assistance, including in Mandarin. If you’re a Jet Card holder, your flight also comes with in-flight catering for flights across the state or across the water. Plus, pets always fly free.',
    btnLink: '/',
    btnDesc: 'Sign Up for a Jet Card',
  },
  {
    title: 'Exclusive Membership Benefits',
    desc: 'With our Gold and Platinum memberships, you can take all the stress and logistics out of flying. You get a dedicated flight account manager to handle all bookings, luxury chauffeur services to and from the airport, and special requests. It’s flying tailored to your unique needs. ',
    btnLink: '/membership',
    btnDesc: 'Become a Member',
  },
  {
    title: 'Affordable Empty Leg Flights',
    desc: 'Sometimes, private aircraft have to fly back empty. Experience the luxury of private jet travel at a fraction of the cost by hopping on one of these flights! ',
    btnLink: '/emptyLeg',
    btnDesc: 'Explore Empty Leg Flights',
  },
  {
    title: 'Our Commitment to Safety',
    desc: 'We want you to have peace of mind every time you fly. That’s why we connect you with private planes that undergo the highest safety, reliability, and professionalism standards.',
    btnLink: '/emptyLeg',
    btnDesc: 'Explore Empty Leg Flights',
  },
];

const Section = () => {
  return SectionLists.map((section, index) => {
    const { title, desc, btnLink, btnDesc } = section;
    return (
      <SectionContainer key={index}>
        <Title>
          <SvgIcon $size={120} src={`/imgs/svg/jet/Svg-${index}.svg`} alt={title}></SvgIcon>

          <Span>{title}</Span>
          <P $size={16}>{desc}</P>
          {index !== 3 && (
            <Link href={btnLink} $borderColor="#000" $color="#050a30">
              {btnDesc}
            </Link>
          )}
        </Title>
      </SectionContainer>
    );
  });
};

const Question = () => {
  return (
    <Container>
      <Head>
        <H2 $align={'center'}>What Makes Flying with Airacer Better?</H2>
        <P $align={'center'}>
          Airacer makes booking and flying on a private jet easier and more rewarding. Find out
          how. 
        </P>
      </Head>
      <Section />
    </Container>
  );
};

export default Question;
